function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const AtIcon = _ref => {
  let {
    size,
    bg,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.657 2.343C12.146.832 10.137 0 8 0S3.854.832 2.343 2.343C.832 3.854 0 5.863 0 8s.832 4.146 2.343 5.657A7.948 7.948 0 0 0 8 16a7.932 7.932 0 0 0 3.429-.77 1 1 0 1 0-.858-1.806A6.007 6.007 0 0 1 2 8.001c0-3.308 2.692-6 6-6s6 2.692 6 6v1c0 .551-.449 1-1 1s-1-.449-1-1v-4a1 1 0 0 0-1.912-.41A3.972 3.972 0 0 0 8 4.001c-2.206 0-4 1.794-4 4s1.794 4 4 4a3.987 3.987 0 0 0 2.712-1.062A2.995 2.995 0 0 0 13 12.001c1.654 0 3-1.346 3-3v-1a7.948 7.948 0 0 0-2.343-5.657zM8 10c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
  }));
};
AtIcon.defaultProps = {
  size: 16,
  bg: 'currentColor'
};
export default AtIcon;